import React from 'react'
import './MapWidget.css'
import { Map, LayerGroup, FeatureGroup, Popup, ImageOverlay } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

import mapBaseImage from './assets/map_1_overview.png'
import mapLayer1Image from './assets/map_1_overview_1.png'

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

class MapWidget extends React.Component {
  componentDidMount() {
    // this.canvas = new FullCanvas('canvas')
  }

  componentWillUnmount() {
    // this.canvas.destroy()
  }

  handleClick = e => {
    console.log(e)
  }

  render() {
    return (
      <div>
        <Map
          crs={L.CRS.Simple}
          center={[2152, 4218]}
          zoom={-2}
          maxBounds={[[0, 0], [7936, 7936]]}
          attributionControl={false}
          maxZoom={1}
          minZoom={-2}
          zoomDelta={0.5}
          zoomSnap={0}
          zoomControl={false}
          maxBoundsViscosity={1}
          wheelPxPerZoomLevel={100}
          onClick={this.handleClick}
          style={{ height: '800px' }}>

          <LayerGroup>
            <ImageOverlay
              url={mapBaseImage}
              bounds={[[0, 0], [7936, 7936]]}
            />
            <ImageOverlay
              url={mapLayer1Image}
              bounds={[[0, 0], [7936, 7936]]}
            />
          </LayerGroup>

          <LayerGroup onEachLayer={layer => console.log(layer)}>
            <FeatureGroup
              onEachLayer={layer => console.log(layer)}>
              <Popup
                position={[1652, 3272]}
                closeButton={false}
                closeOnEscapeKey={false}
                closeOnClick={false}
                className={'sch-popup'}>A pretty CSS3 popup.<br />Easily customizable.</Popup>

              <Popup
                position={[2734, 5009]}
                closeButton={false}
                closeOnEscapeKey={false}
                closeOnClick={false}
                className={'sch-popup'}>A pretty CSS3 popup.<br />Easily customizable.</Popup>
            </FeatureGroup>
          </LayerGroup>
        </Map>
      </div>
    )
  }
}

export default MapWidget



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/MapWidget_bak.js